import React from 'react'
import { useSelector } from 'react-redux'
import Link from 'redux-first-router-link'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { selectCurrentUserIsAdmin } from 'ducks/currentUser/selectors'
import { SETTINGS_CHANNELS_PAGE } from 'subapps/settings/types'
import Loading from 'core/subapps/Loading'
import { selectFetchAppBootstrapRequest } from 'ducks/bootstrap/selectors/selectFetchAppBootstrapRequest'
import NoAccess from './NoAccess'
import AdminList from '../components/AdminList'

const ErrorInnerContent = ({
  EmptyComponent,
  isEmpty,
  canUseLiveChatFeature,
}) => {
  const isAdmin = useSelector(selectCurrentUserIsAdmin)
  const isAppBootstrapped = useSelector(selectFetchAppBootstrapRequest)?.loaded

  // canUseLiveChatFeature isn't available until the app is bootstrapped
  if (!canUseLiveChatFeature && !isAppBootstrapped) {
    return <Loading />
  }

  if ((isAdmin && isEmpty) || (isAdmin && !canUseLiveChatFeature)) {
    return <EmptyComponent canUseLiveChatFeature={canUseLiveChatFeature} />
  }

  if (isAdmin) {
    return (
      <NoAccess
        title="Oh no, You don’t have access to this channel"
        copy={`It appears that you don’t have access to this channel. Please visit the channel overview page and grant yourself access via the ${app.t(
          'agent'
        )} management section under the channel you would like to access`}
      >
        <Link
          to={{
            type: SETTINGS_CHANNELS_PAGE,
            payload: {
              tab: 'chat',
            },
          }}
        >
          <Button className="grui mt-8">Go to channel overview</Button>
        </Link>
      </NoAccess>
    )
  }

  if (!isAdmin) {
    return (
      <NoAccess
        title="Oh no, You don’t have access to this channel"
        copy="Once you are given access to this channel, you will be able to access all the messages here. Please chat to one of your account admins to give you access:"
      >
        <AdminList />
      </NoAccess>
    )
  }
  return null
}

export default ErrorInnerContent
